<template>
  <div id="app" v-if="show">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta || !$route.meta.keepAlive" />
  </div>
</template>
<script>
import { fetchGetTmpUuid, fetchFbReport, fetchReportEvent, fetchPixelReport } from '@/api'
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY } from './utils/constant'
import Cookies from 'js-cookie'
import { isCurLogin, login } from '@/components/login/login'
import { setCookieFbc, setCookieAdId, getPathLang, setToufang, getTtPixelId, initPlayTemplate } from './utils/base'
import { getPaypalSdk } from './utils/paypal'


export default {
  name: 'App',
  data() {
    return {
      show: false
      // Define any global data properties here
    }
  },
  methods: {
    getUuidCallback(){
      this.show = true
      setTimeout(() => {
        fetchPixelReport({}, 'PageView')
        fetchReportEvent({
          type: 'show',
          position: 'pageView'
        })           
      }, 100);
    },
    async getUuid(){
      try {
        if(Cookies.get(USER_ID_COOKIES_KEY)){
          this.getUuidCallback();
          window[USER_ID_COOKIES_KEY] = Cookies.get(USER_ID_COOKIES_KEY)
          window[USER_TOKEN_COOKIES_KEY] = Cookies.get(USER_TOKEN_COOKIES_KEY)
          return
        }
        await fetchGetTmpUuid()
        this.getUuidCallback();
      }catch (error) {
        console.error('Error fetching UUID:', error)
      }
    },
    reportFb(){
      console.log('reportFb')
    }
  },
  mounted() {
    console.log('12346')
    initPlayTemplate()
    ttq.load(getTtPixelId())
    setToufang.apply(this);
    this.$i18n.locale = getPathLang();
    setTimeout(() => {
      getPaypalSdk()
    }, 0);
    setCookieAdId();
    setCookieFbc();
    this.getUuid()
    isCurLogin.value = login.isLogin()
  }
}
</script>


<style lang="less">

</style>
